import { render } from "./LabelForm.vue?vue&type=template&id=a23fac00&scoped=true"
import script from "./LabelForm.vue?vue&type=script&lang=js"
export * from "./LabelForm.vue?vue&type=script&lang=js"

import "./LabelForm.vue?vue&type=style&index=0&id=a23fac00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23fac00"]])

export default __exports__